// extracted by mini-css-extract-plugin
module.exports = {"popover":"info-popover_popover__30avQ","table":"info-popover_table__3nIDl"};